import { createContext, useContext, useEffect, useState } from "react";

const STR = {
  ar: {
    brand: "شركة العالم لخدمات الطيران",
    brandShort: "العالم للطيران",
    nav_services: "خدماتنا",
    nav_airports: "شبكة المطارات",
    nav_about: "عن الشركة",
    nav_payments: "المدفوعات",
    nav_contact: "تواصل معنا",
    nav_quote: "طلب خدمة",
    nav_whatsapp: "واتساب العمليات",
    hero_badge: "المقر الرئيسي: مطار معيتيقة الدولي (MJI) — طرابلس · عمليات 24/7",
    hero_l1: "شريككم الموثوق لخدمات الطيران",
    hero_l2: "والمناولة الأرضية والإشراف",
    hero_l3: "في جميع المطارات الليبية",
    hero_sub: "من مقرنا الرئيسي بمطار معيتيقة الدولي في طرابلس، نوفر المناولة الأرضية المتكاملة، تصاريح الأجواء الليبية، وتزويد وقود Jet A-1 على مدار الساعة بدقة واحترافية دولية.",
    hero_cta1: "طلب خدمة فورية / عرض أسعار",
    hero_cta2: "استكشف شبكة المطارات",
    hero_scroll: "مرر للاستكشاف",
    services_eyebrow: "منظومة الخدمات",
    services_title: "كل ما تحتاجه طائرتك على الأراضي الليبية",
    services_sub: "ست ركائز تشغيلية متكاملة تغطي رحلتكم من لحظة طلب التصريح حتى الإقلاع.",
    airports_eyebrow: "شبكة التغطية",
    airports_title: "نغطي كل مدرج في ليبيا",
    airports_sub: "اختر أي مطار على الخريطة لعرض جاهزيته التشغيلية وخدماته المتاحة.",
    airport_runway: "المدرج",
    airport_status: "الحالة",
    airport_services: "الخدمات المتاحة",
    airport_book: "اطلب المناولة في هذا المطار",
    hq_badge: "المقر الرئيسي",
    about_eyebrow: "من نحن",
    about_title: "خبرة ليبية بمعايير عالمية",
    about_lead: "شركة العالم لخدمات الطيران (WAS) — مقرها طرابلس — هي الذراع التشغيلية التي تعتمد عليها شركات الطيران العالمية ومشغلو الطيران الخاص لضمان رحلات آمنة ودقيقة في كل مطار ليبي.",
    vision_label: "رؤيتنا",
    vision: "أن نكون المنظومة الوطنية الرائدة والأكثر موثوقية في ليبيا وشمال أفريقيا، نربط سماء ليبيا بالعالم عبر معايير طيران لا تقبل المساومة.",
    mission_label: "رسالتنا",
    mission: "تقديم حلول دعم طيران شاملة على مدار 24 ساعة لشركات الطيران العالمية والطيران الخاص في كافة المطارات الليبية بسرعة وأمان وشفافية مطلقة.",
    why_title: "لماذا شركة العالم؟",
    compliance_title: "الالتزام بالسلامة والجودة العالمية",
    quote_eyebrow: "طلب خدمة",
    quote_title: "احصل على عرض سعر خلال ساعات",
    quote_sub: "نموذج مخصص لشركات الطيران والطيران الخاص — يصل مباشرة إلى مركز عملياتنا.",
    f_service: "نوع الخدمة",
    f_aircraft: "نوع الطائرة (مثال: A320, B737, G650)",
    f_callsign: "نداء الرحلة / رقم التسجيل",
    f_airport: "المطار",
    f_eta: "تاريخ الوصول المتوقع (ETA)",
    f_operator: "اسم المشغل / الشركة *",
    f_person: "اسم المسؤول للتواصل",
    f_email: "البريد الإلكتروني للعمليات *",
    f_phone: "رقم الهاتف / واتساب",
    f_details: "متطلبات إضافية (وقود بالطن، تموين، تصاريح عاجلة، فندقة للطاقم...)",
    f_submit: "إرسال الطلب إلى العمليات",
    f_submitting: "جارٍ الإرسال...",
    f_success: "تم استلام طلبكم — رقم المرجع",
    f_success_desc: "أرسلنا تأكيداً إلى بريدكم، وسيتواصل معكم فريق العمليات قريباً.",
    f_error: "تعذر إرسال الطلب — يرجى المحاولة عبر واتساب",
    f_whatsapp_followup: "متابعة عبر واتساب",
    contact_title: "مركز العمليات — طرابلس",
    contact_247: "متاحون على مدار الساعة 24/7/365",
    contact_ops: "بريد العمليات",
    contact_ceo: "الإدارة التنفيذية",
    contact_phone: "هاتف / واتساب",
    contact_hq: "المقر الرئيسي",
    contact_hq_value: "مطار معيتيقة الدولي، طرابلس — ليبيا",
    pay_eyebrow: "المدفوعات الإلكترونية",
    pay_title: "رسوم الخدمات بأمان عبر الإنترنت",
    pay_sub: "لعملائنا من شركات الطيران والمشغلين: ادفعوا العربون ورسوم التصاريح عبر Stripe أو PayPal — بالدولار الأمريكي وبتأكيد فوري.",
    pay_button: "ادفع عبر Stripe",
    pay_processing: "جارٍ تحويلك لبوابة الدفع...",
    pay_paypal_title: "أو ادفع عبر PayPal",
    pay_paypal_pending: "بوابة PayPal جاهزة تقنياً — تُفعَّل فور اعتماد بيانات حساب PayPal التجاري.",
    pay_per_txn: "لكل عملية",
    pay_secure: "مدفوعات مشفرة وآمنة 100%",
    pay_status_success: "تم استلام دفعتكم بنجاح",
    pay_status_success_desc: "شكراً لكم — سيصلكم تأكيد من فريق العمليات. احتفظوا برقم العملية كمرجع.",
    pay_status_pending: "جارٍ التحقق من الدفعة...",
    pay_status_failed: "لم تكتمل الدفعة",
    pay_status_failed_desc: "إن خُصم المبلغ سيتواصل معكم فريقنا. للمساعدة الفورية راسلونا على بريد العمليات.",
    pay_status_cancel: "تم إلغاء عملية الدفع",
    pay_status_cancel_desc: "لم يتم خصم أي مبلغ. يمكنكم إعادة المحاولة في أي وقت.",
    pay_back: "العودة للرئيسية",
    pay_ref: "مرجع العملية",
    footer_tag: "شريككم الموثوق لخدمات الطيران والمناولة الأرضية في جميع المطارات الليبية",
    footer_links: "روابط سريعة",
    footer_contact: "التواصل",
    footer_airports: "محطات التغطية",
    footer_rights: "© 2026 شركة العالم لخدمات الطيران — جميع الحقوق محفوظة",
    menu_open: "فتح القائمة",
    menu_close: "إغلاق القائمة",
    nav_rahalty: "رحلتي",
    rahalty_cta: "اكتشف نظام رحلتي",
    theme_toggle: "الوضع النهاري / الليلي",
    rahalty_eyebrow: "منظومتنا التقنية",
    rahalty_title: "رحلتي — نظام إدارة العمليات الأرضية والجوية",
    rahalty_desc: "نظام متكامل من تطوير شركة العالم لخدمات الطيران، لإدارة العمليات الأرضية والجوية وتوثيق كل ما يتعلق بالرحلة — من لحظة الإقلاع حتى الهبوط، لحظة بلحظة.",
    rahalty_f1: "إدارة العمليات الأرضية",
    rahalty_f2: "المتابعة الجوية المباشرة",
    rahalty_f3: "توثيق كامل للرحلة",
    rahalty_f4: "تقارير وسجلات فورية",
    rahalty_badge: "من تطوير شركة العالم",
  },
  en: {
    brand: "World Aviation Services",
    brandShort: "WAS Libya",
    nav_services: "Services",
    nav_airports: "Airports Network",
    nav_about: "About WAS",
    nav_payments: "Payments",
    nav_contact: "Contact",
    nav_quote: "Request Quote",
    nav_whatsapp: "Ops WhatsApp",
    hero_badge: "HQ: Mitiga Intl Airport (MJI) — Tripoli · 24/7 OCC",
    hero_l1: "Your Trusted Aviation Partner",
    hero_l2: "Ground Handling & Supervision",
    hero_l3: "Across Every Libyan Airport",
    hero_sub: "From our headquarters at Mitiga International Airport, Tripoli, we deliver integrated ramp handling, Libyan FIR permits and Jet A-1 fueling around the clock — to uncompromising ICAO & IATA standards.",
    hero_cta1: "Request Service / Get a Quote",
    hero_cta2: "Explore the Network",
    hero_scroll: "Scroll to explore",
    services_eyebrow: "Service Ecosystem",
    services_title: "Everything Your Aircraft Needs on Libyan Soil",
    services_sub: "Six integrated operational pillars covering your flight from permit request to wheels-up.",
    airports_eyebrow: "Coverage Network",
    airports_title: "We Cover Every Runway in Libya",
    airports_sub: "Select any airport on the map to view its operational readiness and available services.",
    airport_runway: "Runway",
    airport_status: "Status",
    airport_services: "Available Services",
    airport_book: "Book Handling at this Airport",
    hq_badge: "Headquarters",
    about_eyebrow: "Who We Are",
    about_title: "Libyan Expertise, Global Standards",
    about_lead: "Headquartered in Tripoli, World Aviation Services (WAS) is the operational arm trusted by international airlines and private operators for safe, precise turnarounds at every Libyan airport.",
    vision_label: "Our Vision",
    vision: "To be the premier, most trusted aviation support ecosystem in Libya and North Africa — connecting Libyan skies with the world through uncompromising standards.",
    mission_label: "Our Mission",
    mission: "Delivering 24/7 comprehensive aviation support to global airlines and private operators across all Libyan airports — fast, safe, and fully transparent.",
    why_title: "Why WAS?",
    compliance_title: "Safety & Global Quality Compliance",
    quote_eyebrow: "Request a Service",
    quote_title: "Get a Quote Within Hours",
    quote_sub: "A dedicated form for airlines and private aviation — straight to our Operations Control Center.",
    f_service: "Service Type",
    f_aircraft: "Aircraft Type (e.g. A320, B737, G650)",
    f_callsign: "Callsign / Tail Registration",
    f_airport: "Airport",
    f_eta: "Estimated Date of Arrival (ETA)",
    f_operator: "Operator / Company Name *",
    f_person: "Contact Person",
    f_email: "Operations Email *",
    f_phone: "Phone / WhatsApp",
    f_details: "Additional requirements (fuel uplift in MT, catering, urgent permits, crew hotel...)",
    f_submit: "Send to Operations",
    f_submitting: "Sending...",
    f_success: "Request received — Reference",
    f_success_desc: "A confirmation was emailed to you; our ops team will reach out shortly.",
    f_error: "Could not send the request — please try WhatsApp",
    f_whatsapp_followup: "Follow up on WhatsApp",
    contact_title: "Operations Center — Tripoli",
    contact_247: "Available 24/7/365",
    contact_ops: "Operations Email",
    contact_ceo: "Executive Office",
    contact_phone: "Phone / WhatsApp",
    contact_hq: "Headquarters",
    contact_hq_value: "Mitiga International Airport, Tripoli — Libya",
    pay_eyebrow: "Online Payments",
    pay_title: "Settle Service Fees Securely Online",
    pay_sub: "For our airline and operator clients: pay deposits and permit fees via Stripe or PayPal — in USD with instant confirmation.",
    pay_button: "Pay with Stripe",
    pay_processing: "Redirecting to checkout...",
    pay_paypal_title: "Or pay with PayPal",
    pay_paypal_pending: "PayPal gateway is code-ready — it activates the moment business PayPal credentials are approved.",
    pay_per_txn: "per transaction",
    pay_secure: "100% encrypted & secure",
    pay_status_success: "Payment Received Successfully",
    pay_status_success_desc: "Thank you — our operations team will confirm shortly. Keep the transaction reference.",
    pay_status_pending: "Verifying your payment...",
    pay_status_failed: "Payment Not Completed",
    pay_status_failed_desc: "If the amount was debited, our team will contact you. For urgent help email operations.",
    pay_status_cancel: "Payment Cancelled",
    pay_status_cancel_desc: "No amount was charged. You can retry anytime.",
    pay_back: "Back to Home",
    pay_ref: "Transaction reference",
    footer_tag: "Your trusted partner for aviation support & ground handling across all Libyan airports",
    footer_links: "Quick Links",
    footer_contact: "Contact",
    footer_airports: "Coverage Stations",
    footer_rights: "© 2026 World Aviation Services (WAS) — All rights reserved",
    menu_open: "Open menu",
    menu_close: "Close menu",
    nav_rahalty: "Rahalty",
    rahalty_cta: "Explore Rahalty System",
    theme_toggle: "Light / Dark mode",
    rahalty_eyebrow: "Our Technology",
    rahalty_title: "Rahalty — Ground & Flight Operations System",
    rahalty_desc: "A proprietary platform developed by World Aviation Services to manage ground and flight operations — documenting everything related to each flight, from takeoff to touchdown, moment by moment.",
    rahalty_f1: "Ground Ops Management",
    rahalty_f2: "Live Flight Watch",
    rahalty_f3: "Full Flight Documentation",
    rahalty_f4: "Instant Reports & Logs",
    rahalty_badge: "Developed by WAS",
  },
};

export const SERVICE_OPTIONS = {
  ar: ["مناولة أرضية", "تصريح عبور / هبوط", "تزويد وقود Jet A-1", "مناولة كبار الشخصيات VIP", "دعم شحن جوي", "إشراف ومتابعة 24/7", "حزمة شاملة"],
  en: ["Ground Handling", "Overflight / Landing Permit", "Jet A-1 Fueling", "VIP Executive Handling", "Cargo & Freighter Support", "Flight Supervision 24/7", "Comprehensive Full Package"],
};

export const AIRPORT_OPTIONS = [
  "Mitiga (MJI / HLLM) — HQ", "Benina (BEN / HLLB)", "Misrata (MRA / HLMS)", "Sebha (SEB / HLLS)",
  "Labraq (LAQ / HLLQ)", "Tobruk (TOB / HLTQ)", "Kufra (KFR / HLKF)", "Tripoli FIR (Overflight Only)",
];

export const PAY_PACKAGES = [
  { id: "permit_priority", amount: 250, desc_ar: "إصدار عاجل لتصاريح العبور والهبوط في الأجواء الليبية", desc_en: "Expedited Libyan FIR overflight & landing permit processing" },
  { id: "handling_deposit", amount: 500, desc_ar: "عربون حجز خدمات المناولة الأرضية في أي مطار ليبي", desc_en: "Booking deposit for ground handling at any Libyan airport" },
  { id: "vip_deposit", amount: 1000, desc_ar: "عربون حزمة كبار الشخصيات والطيران الخاص", desc_en: "Deposit for VIP executive & private aviation package" },
];

const LangCtx = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState("ar");
  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);
  const t = (key) => STR[lang][key] ?? key;
  return <LangCtx.Provider value={{ lang, setLang, t, isAr: lang === "ar" }}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);

export const goTo = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70 });
  else el.scrollIntoView({ behavior: "smooth" });
};
